<template>
  <div style="width:100%;height:100%; position: relative;">
    <div style="height:40px;width:100%;">
      <!-- <p
        v-if="isOk"
        class="title"
      ></p>
      <p
        v-if="!isOk"
        class="title"
      >{{title}}</p> -->
      <div
        v-if="isOk"
        class="radiodiv"
      >
        <el-radio
          v-model="radio"
          @change="change1"
          label="1"
          class="radio"
        >Government Bond Yield Curve</el-radio>
        <el-radio
          v-model="radio"
          @change="change"
          label="2"
          id="radios"
          class="radio"
        >Stock Market Index</el-radio>
        <el-radio
          v-model="radio"
          @change="change2"
          label="3"
          class="radio"
        >Interest Rates</el-radio>
      </div>
    </div>
    <div style="position: absolute;top: 48px;bottom:0;left:0;width:92%;height: 89%">
      <div
        v-if="chang===1"
        id="echart3"
        style="width:100%;height:90%;"
      ></div>
      <div
        v-else-if="chang===2"
        id="echar2"
        style="width:100%;height:90%;"
      ></div>
      <div
        v-else-if="chang===3"
        id="echart1"
        style="width:100%;height:90%;"
      ></div>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-unused-vars,eqeqeq */
import echarts from 'echarts'
import { getDataCommon } from "common/js/http/v3Api"
export default {
  props: {
    country: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      id: 'F01_05_01',
      code: null,
      pagesize: 10,
      begindate: null,
      enddate: null,
      other: null,
      radio: '1',
      chartLine: null,
      chartLine2: null,
      lined: null,
      idxlist: null,
      lind2: [],
      list2: [],
      isOk: true,
      isOk1: true,
      chang: 1,
      chartbar: '',
      label2: '',
      title: '',
      count: 0,
      rateLabel: ''
    }
  },
  computed: {
    interestRateCode() {
      return this.$store.state.common.interestRateCode
    },
    interestRateLabel() {
      return this.$store.state.common.interestRateLabel
    }
  },
  watch: {
    interestRateCode: function(n, o) {
      if (this.isOk === true) {
        if (this.count === 0) {
          this.count++
          return
        }
        this.radio = '3'
        this.chang = 3
      }
      this.isOk1 = false
      this.other = n
      this.getInterestRateData()
    },
    interestRateLabel(n, o) {
      this.title = n
    },
    lined(n, o) {
      this.initChart()
    },
    idxlist(n, o) {
      this.initChart()
    }
  },
  mounted() {
    this.code = this.country.countryCode
    if (this.code === '1' || this.code === 1 || this.code === '7' || this.code === 7 || this.code === '9' || this.code === 9 || this.code === '10' || this.code === 10) {
      this.isOk = false
    } else {
      this.isOk = true
    }
    this.getDataCommon()
    this.getArray()
    if (this.code === '3' || this.code === '6') {
      var r = document.getElementById('radios')
      r.style.display = 'none'
    }
  },
  activated() {
    // 由于给echart添加了resize事件, 在组件激活时需要重新resize绘画一次, 否则出现空白bug
    if (this.chartLine) {
      this.chartLine.resize()
    }
    if (this.chartLine2) {
      this.chartLine2.resize()
    }
    if (this.chartbar) {
      this.chartbar.resize()
    }
  },
  methods: {
    change1(val) {
      if (val === '1') {
        this.chang = 1
        this.isOk1 = true
        this.$nextTick(function() {
          this.getData()
        })
      }
    },
    change(val) {
      if (val === '2') {
        this.chang = 2
        this.$nextTick(function() {
          this.initBars1()
        })
      }
    },
    change2(val) {
      if (val === '3') {
        this.chang = 3
        this.isOk1 = false
        this.$nextTick(function() {
          this.other = this.interestRateCode
          this.getInterestRateData()
        })
      }
    },
    // 折线图
    initChart() {
      var option = {
        grid: {
          left: '2%',
          right: '20',
          top: '10',
          bottom: '20',
          containLabel: true
        },
        color: ['#3fb1e3', '#cc70af', '#ffb980', '#9b8bba',
          '#e098c7', '#97b552', '#d87a80', '#eedd78',
          '#2ec7c9', '#626c91', '#cbb0e3', '#73a373', '#8dc1a9',
          '#97d4dc', '#82c0c9', '#b7dba1', '#a0a7e6', '#6be6c1'],
        'tooltip': {
          'trigger': 'axis',
          backgroundColor: '#9ca0a9',
          axisPointer: {
            type: 'line',
            lineStyle: {
              width: '0.5',
              type: 'dashed'
            }
          },
          formatter: (params) => {
            if (this.isOk1) {
              return 'Date：' + params[0].data.date + '<br/>Government Bond：' + params[0].data.name + '<br/>Yield：' + params[0].data.value
            } else {

              return 'Date：' + params[0].name + '<br/>Interest Rate：' + params[0].data
            }
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: true,
          data: this.lined,
          axisTick: {
            show: true,
            lineStyle: {
              color: '#DFE1E5'
            }
          },
          axisLine: { show: false }
        },
        yAxis: {
          type: 'value',
          scale: true,
          axisTick: {
            show: false
          },
          axisLine: { show: false },
          splitLine: {
            show: true,
            lineStyle: {
              color: ['#dfe1e5']
            }
          }
        },
        series: [{
          data: this.idxlist,
          showSymbol: false,
          symbolSize: 0.5,
          symbol: 'circle',
          type: 'line'
        }]
      }
      if (this.isOk1 || this.code === '1' || this.code === 1 || this.code === '7' || this.code === 7 || this.code === '9' || this.code === 9 || this.code === '10' || this.code === 10) {
        this.chartLine = echarts.init(document.getElementById('echart3'))
        this.chartLine.clear()
        this.chartLine.setOption(option)
        window.addEventListener('resize', () => {
          this.chartLine.resize()
        })
      } else {
        this.chartLine2 = echarts.init(document.getElementById('echart1'))
        this.chartLine2.clear()
        this.chartLine2.setOption(option)
        window.addEventListener('resize', () => {
          this.chartLine2.resize()
        })
      }
    },
    initBars1() {
      var option = {
        grid: {
          left: '40',
          right: '85',
          top: '10',
          bottom: '40',
          containLabel: true
        },
        color: ['#3fb1e3', '#cc70af', '#ffb980', '#9b8bba',
          '#e098c7', '#97b552', '#d87a80', '#eedd78',
          '#2ec7c9', '#626c91', '#cbb0e3', '#73a373', '#8dc1a9',
          '#97d4dc', '#82c0c9', '#b7dba1', '#a0a7e6', '#6be6c1'],
        'tooltip': {
          'trigger': 'axis',
          backgroundColor: '#9ca0a9',
          axisPointer: {
            type: 'line',
            lineStyle: {
              width: '0.5',
              type: 'dashed'
            }
          },
          formatter: (params) => {
            var str = ''
            if (params[0] != null) {
              str += 'Date：' + params[0].axisValue + '<br />'
              str += '' + params['0'].seriesName + '：' + params['0'].value + '<br />'
            }
            return str
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: true,
          data: this.list2,
          axisTick: {
            show: true,
            lineStyle: {
              color: '#DFE1E5'
            }
          },
          axisLine: { show: false }
        },
        dataZoom: [
          {
            type: 'slider', // 图表下方的伸缩条
            show: true,  // 是否显示
            realtime: true,  //
            start: 80,  // 伸缩条开始位置（1-100），可以随时更改
            end: 100,  // 伸缩条结束位置（1-100），可以随时更改
            bottom: 15,
            height: 20
          }
        ],
        yAxis: {
          type: 'value',
          scale: true,
          axisTick: {
            show: false
          },
          axisLine: { show: false },
          splitLine: {
            show: true,
            lineStyle: {
              color: ['#dfe1e5']
            }
          }
        },
        series: [{
          name: this.label2,
          data: this.lind2,
          showSymbol: false,
          symbolSize: 0.5,
          symbol: 'circle',
          type: 'line'
        }]
      }
      this.chartbar = echarts.init(document.getElementById('echar2'))
      // console.log(JSON.stringify(option))
      this.chartbar.clear()
      this.chartbar.setOption(option)
      window.addEventListener('resize', () => {
        this.chartbar.resize()
      })
    },
    // 政府债券收益率曲线
    /* async getDMData() {
      const { data } = await getDMData({
        'id': this.id,
        'code': this.code,
        'pagesize': this.pagesize,
        'begindate': this.begindate,
        'enddate': this.enddate,
        'other': this.other
      });
      if (data != null && data.length !== 0) {
        if (data[0] != null) {
          var arr1 = data[0].Lined.split(',').map(item => item.replace(/\'/g, ''))
          var arr2 = data[0].value.split(',').map(item => item.replace(/\'/g, ''))
          var arr3 = data[0].DATADATE.split(',').map(item => item.replace(/\'/g, ''))
          this.lined = arr1
          // this.idxlist = arr2
          var array = []
          for (var i = 0; i < arr1.length; i++) {
            array.push({ value: arr2[i], date: arr3[i], name: arr1[i] })
          }
          this.idxlist = array
          // console.log(this.idxlist);
        }
      }
    }, */
    async getDataCommon() {
      const { data } = await getDataCommon({
        'fcode': 'F01_05_01',
        'countryCode': this.country.countryCode,
        'pagesize': this.pagesize,
        't': new Date().getTime(),
        'other': this.other,
        'locales': 'en'
      }, { 'Content-Type': 'application/json;charset=utf8', 'API-TOKEN': '2CCA56D9D84849551E943895153D5AD5' })
      this.gbycData = data.result.data
      if (this.gbycData != null && this.gbycData.length !== 0) {
        if (this.gbycData[0] != null) {
          var arr1 = this.gbycData[0].Lined.split(',').map(item => item.replace(/\'/g, ''))
          var arr2 = this.gbycData[0].value.split(',').map(item => item.replace(/\'/g, ''))
          var arr3 = this.gbycData[0].DATADATE.split(',').map(item => item.replace(/\'/g, ''))
          this.lined = arr1
          // this.idxlist = arr2
          var array = []
          for (var i = 0; i < arr1.length; i++) {
            array.push({ value: arr2[i], date: arr3[i], name: arr1[i] })
          }
          this.idxlist = array
        }
      }
    },
    async getInterestRateData() {// 利率
      const { data } = await getDataCommon({
        'fcode': 'F01_05_03',
        'countryCode': this.country.countryCode,
        'pagesize': this.pagesize,
        't': new Date().getTime(),
        'other': this.other,
        'locales': 'en'
      }, { 'Content-Type': 'application/json;charset=utf8', 'API-TOKEN': '2CCA56D9D84849551E943895153D5AD5' })
      let rateData = data.result.data
      if (rateData != null && rateData.length !== 0) {
        this.lined = rateData[0].DATADATE.split(',').map(item => item.replace(/\'/g, ''))
        this.idxlist = rateData[0].value.split(',').map(item => item.replace(/\'/g, ''))
        this.rateLabel = rateData[0].label
      }
    },
    async getArray() {// 股指
      /* const { data } = await getDMData({
        'id': 'F01_05_01_C',
        'code': this.code,
        'pagesize': '360',
        'begindate': this.begindate,
        'enddate': this.enddate,
        'other': this.other
      }) */
      const { data } = await getDataCommon({
        'fcode': 'F01_05_01_C',
        'countryCode': this.country.countryCode,
        'pagesize': this.pagesize,
        't': new Date().getTime(),
        'other': this.other,
        'locales': 'en'
      }, { 'Content-Type': 'application/json;charset=utf8', 'API-TOKEN': '2CCA56D9D84849551E943895153D5AD5' })
      let arrData = data.result.data
      if (arrData != null && arrData.length !== 0) {
        if (arrData[0].DATE1) {
          this.list2 = arrData[0].DATE1.split(',').map(item => item.replace(/\'/g, ''))
        }
        if (arrData[0].CLS_PRC) {
          this.lind2 = arrData[0].CLS_PRC.split(',').map(item => item.replace(/\'/g, ''))
        }
        if (arrData[0].LABEL_EN) {
          this.label2 = arrData[0].LABEL_EN.split(',').map(item => item.replace(/\'/g, ''))
        }
      }
    }
  }
}
</script>
<style scoped lang="scss">
.title {
  font-size: 17px;
  color: #4c5e70;
  margin: 10px 0 0 5px;
}
.radiodiv {
  margin-top: 10px;
  margin-left: 10px;
}
.radio {
  font-size: 14px;
  color: #636363;
}
</style>
